import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import HotelManagementService from '@/service/HotelManagementService';

export const usePreferredManagementStore = defineStore('usePreferredManagementStore', {
  state: () => ({}),
  getters: {},
  actions: {
    async handleUpdateStatusPreferred(code, type, payload) {
      const hotelManagementService = new HotelManagementService();
      try {
        await hotelManagementService.updatePreferred(code, type, payload);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    }
  }
});
